class Storage{
    constructor(name=''){
        this.name=name;
    }
    get(){
        return JSON.parse(localStorage.getItem(this.name))||localStorage.getItem(this.name);
    }
    set(data){
        var d=JSON.stringify(data)||data;
        localStorage.setItem(this.name,d);
    }
    remove(){
        localStorage.removeItem(this.name);
    }
    static clear(){
        localStorage.clear();
    }
}
export class CompanyStorage extends Storage{
    constructor(){
        super('company_selected');
    }
}
export class CartStorage extends Storage{
    constructor(){
        super('cart');
    }
}
export class RoutesStorage extends Storage{
    constructor(){
        super('routes');
    }
}
export class OrderStorage extends Storage{
    constructor(){
        super('order');
    }
}
export class FavoritesStorage extends Storage{
    constructor(){
        super('favorites');
    }
}
export class OrderDetailStorage extends Storage{
    constructor(){
        super('order_detail');
    }
}
export class UsersStorage extends Storage{
    constructor(){
        super('user');
    }
}
export class IdentStorage extends Storage{
    constructor(){
        super('iden');
    }
}
export class CouponStorage extends Storage{
    constructor(){
        super('coupon');
    }
}
export class HelpStorage extends Storage{
    constructor(){
        super('help');
    }
}
export class HelpModalStorage extends Storage{
    constructor(){
        super('help-modal');
    }
}
export class LocationStorage extends Storage{
    constructor(){
        super('location');
    }
}
export class SymptomsStorage extends Storage{
    constructor(){
        super('symptoms');
    }
}
export class ReferredStorage extends Storage{
    constructor(){
        super('referred');
    }
}
export class ActiveLocationStorage extends Storage{
    constructor(){
        super('activeLocation');
    }
}
export class SearchListStorage extends Storage{
    constructor(){
        super('searchList');
    }
}